const options = {
  5: "bg-lime-600/5",
  10: "bg-lime-600/10",
  25: "bg-lime-600/25",
  50: "bg-lime-600/50",
  75: "bg-lime-600/75",
  90: "bg-lime-600/90",
  100: "bg-lime-600",
};

const from = {
  5: "from-lime-600/5",
  10: "from-lime-600/10",
  25: "from-lime-600/25",
  50: "from-lime-600/50",
  75: "from-lime-600/75",
  90: "from-lime-600/90",
  100: "from-lime-600",
};

export default function getBackgroundLime600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
